import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#4ade80',
      light: '#7bedaf',
      dark: '#22c55e',
    },
    secondary: {
      main: '#22d3ee',
      light: '#67e8f9',
      dark: '#0ea5e9',
    },
    background: {
      default: '#020617',
      paper: '#0b1224',
    },
    text: {
      primary: '#e2e8f0',
      secondary: '#94a3b8',
    },
  },
  typography: {
    fontFamily:
      '"Share Tech Mono", "Audiowide", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.4rem',
      fontWeight: 600,
      '@media (max-width: 767px)': {
        fontSize: '1.8rem',
      },
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
      '@media (max-width: 767px)': {
        fontSize: '2rem',
      },
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 600,
      '@media (max-width: 767px)': {
        fontSize: '1.5rem',
      },
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#020617',
          color: '#e2e8f0',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '10px',
          fontWeight: 600,
          letterSpacing: '0.04em',
          border: '1px solid rgba(34, 211, 238, 0.25)',
          background:
            'radial-gradient(circle at 10% 20%, rgba(34,211,238,0.12) 0, rgba(2,6,23,0.4) 45%), linear-gradient(120deg, rgba(34,211,238,0.16), rgba(74,222,128,0.18))',
          boxShadow:
            '0 0 0 1px rgba(148, 163, 184, 0.15), 0 12px 40px -15px rgba(34, 211, 238, 0.4)',
          transition: 'all 0.25s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow:
              '0 0 0 1px rgba(74, 222, 128, 0.45), 0 14px 44px -14px rgba(74, 222, 128, 0.45)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(11, 18, 36, 0.85)',
          border: '1px solid rgba(34, 211, 238, 0.2)',
        },
      },
    },
  },
});
